import type { GameGuide } from '@songie/game-kit/client';

export const guide: GameGuide = {
  summary: 'Zar at, şehir al, otel dik. Rakibin senin otelinin kirasıyla batsın. Şans kartı çıkarsa istersen gerçek hayat görevi yap.',
  players: '2–12 oyuncu (tekli en fazla 8)',
  duration: '15–30 dk',
  sections: [
    {
      title: 'Amaç',
      body: 'Herkes 20 Mn ile başlar. Bunlardan biri kazandırır: bir kenarın tamamı, 3 renk grubu, 4 tatil beldesi ya da tek başına ayakta kalmak. Bu tekeller 3 tur dönmeden sayılmaz. Süre dolarsa en zengin kazanır; servet, para ile şehirlere yatırılan paranın toplamıdır.',
    },
    {
      title: 'Sıra sende',
      body: "Zar at, piyonun yürür. Geldiğin kareye göre karar verirsin. Her kararın süresi var; süre dolunca otomatik geçilir. Başla'dan her geçişte 3 Mn alırsın.",
    },
    {
      title: 'Şehirler',
      items: [
        { term: 'Satın al', text: "İlk turda 1 ya da 2 evle alırsın. Başla'dan geçtikten sonra 3 eve kadar alabilirsin.", tone: 'green' },
        { term: 'Yükselt', text: "Kendi şehrine gelince yükseltirsin. 3. ev için Başla'dan geçmiş olman gerekir, otel yalnızca 3 evli şehre yapılır.", tone: 'yellow' },
        { term: 'Renk grubu', text: 'Grubun bütün şehirleri sendeyse kira 1,5 kat olur.', tone: 'purple' },
        { term: 'Geri satın al', text: 'Rakibin şehrinde kira ödedikten sonra, otel değilse şehri yatırılan paranın 2 katına alabilirsin.', tone: 'orange' },
        { term: 'Tatil beldesi', text: 'Yükseltilmez, geri satın alınamaz. Kirası sahip olduğun belde sayısıyla katlanır.', tone: 'neutral' },
        { term: 'Festival', text: 'Oyun başında 2 şehirde festival olur, kirası 2 kattır.', tone: 'neutral' },
      ],
    },
    {
      title: 'Şans kartı ve görev',
      body: 'Şans karesinde bir oyun kartı ve seçili paketlerden bir gerçek görev çıkar. Kartı uygula ya da görevi yap.\n\nGörevi seçersen süre işler. Bitirince rakipler "Yaptı" ya da "Yapamadı" der; eşitlikte görev başarılı sayılır. Başarırsan kötü kart iptal olur, iyi kartın parası 2 katına çıkar. Yapamazsan kart uygulanır.',
      tip: 'İstemediğin bir görev mi çıktı? Kartı uygula yeter, kimse zorunda değil.',
    },
    {
      title: 'Özel kareler',
      items: [
        { term: 'Şampiyona', text: 'Kendi şehirlerinden birini seçersin, kirası 2 katına çıkar. Yeni şampiyonayla yeniden katlanır.', tone: 'yellow' },
        { term: 'Dünya Turu', text: 'Sonraki sıranda 500 bin ödeyip boş şehre, kendi şehrine ya da bir beldeye uçabilir, istersen normal zar atabilirsin.', tone: 'neutral' },
        { term: 'Kayıp Ada', text: 'En fazla 3 tur kalırsın. Çift at ya da 2 Mn öde.', tone: 'neutral' },
        { term: 'Vergi', text: 'Varlığının onda birini (en az 1 Mn) ödersin.', tone: 'neutral' },
      ],
    },
    {
      title: 'Borç ve iflas',
      body: 'Paran yetmezse şehir satarsın; yatırdığın paranın tamamını geri alırsın. Yine yetmezse iflas edersin, kalan paran alacaklıya, şehirlerin bankaya gider.',
    },
    {
      title: 'Ayarlar',
      items: [
        { term: 'Tekli ya da takımlı', text: 'Takımların tek piyonu, ortak parası ve şehirleri vardır; üyeler sırayla oynar. Takımlar eşit olmak zorunda değil.', tone: 'neutral' },
        { term: 'Oyun süresi', text: '15, 20 ya da 30 dakika.', tone: 'neutral' },
        { term: 'Gerçek hayat görevleri', text: 'Kapatırsan şans kartları yalnızca oyun içi uygulanır.', tone: 'neutral' },
        { term: 'Görev paketleri', text: 'Hareket, Taklit, Dans, Şarkı, Komik, Cesaret ve Arkadaş görevleri. Arkadaş görevleri yalnızca odadaki oyuncuların yazdıklarından çıkar. Cesur ve Ateşli (+18) paketler yetişkinler içindir, varsayılan olarak kapalıdır.', tone: 'neutral' },
      ],
    },
  ],
};
